/* eslint-disable valid-jsdoc */
import {
  round,
} from '../utils';

/**
 * This function formats currency.
 * @param  {string or integer} amount
 * @returns {string} formatted currency amount
 */
export function formatCurrency(amount) {
  if (amount) {
    let a = amount;
    if (typeof amount === 'string') {
      a = parseFloat(a);
    }
    if (amount >= 0) {
      return `$${numberWithCommas(round(a).toFixed(2))}`;
    } else {
      return `$(${numberWithCommas(round(a * -1).toFixed(2))})`;
    }
  }
  return '$0.00';
}

export function numberWithCommas(x) {
  if (!x) return '';
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function convertToCents(dollars, roundNumber = true) {
  if (dollars) {
    const convertedValue = (dollars * 100);
    if (roundNumber) {
      return Math.round(convertedValue);
    }
    return convertedValue;
  }
  return dollars;
}

export function convertToDollar(cents, rounding = true) {
  const dollars = cents / 100;
  if (rounding) {
    return round(dollars);
  }
  return dollars;
}
